/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PutUpdatePrintProofReviewMutationRequest, PutUpdatePrintProofReviewMutationResponse, PutUpdatePrintProofReviewPathParams, PutUpdatePrintProofReviewQueryParams, PutUpdatePrintProofReview400, PutUpdatePrintProofReview404 } from "../../models/PutUpdatePrintProofReview";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPutUpdatePrintProofReviewUrl({ uuid }: { uuid: PutUpdatePrintProofReviewPathParams["uuid"] }) {
  const res = { method: 'PUT', url: `/api/v1/configurations/${uuid}/print-proof/review` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:uuid/print-proof/review}
 */
export async function putUpdatePrintProofReview({ uuid, data, params }: { uuid: PutUpdatePrintProofReviewPathParams["uuid"]; data: PutUpdatePrintProofReviewMutationRequest; params: PutUpdatePrintProofReviewQueryParams }, config: Partial<RequestConfig<PutUpdatePrintProofReviewMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PutUpdatePrintProofReviewMutationResponse, ResponseErrorConfig<PutUpdatePrintProofReview400 | PutUpdatePrintProofReview404>, PutUpdatePrintProofReviewMutationRequest>({ method : "PUT", url : getPutUpdatePrintProofReviewUrl({ uuid }).url.toString(), params, data : requestData, ... requestConfig })  
  return res.data
}